import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    TextField,
} from '@material-ui/core';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerModelField from './InfluencerModelField';
import { AuthContext } from '../../Authentication/AuthContext';


type Props = {
    open: boolean;
    onClose: () => void;
    influencer: InfluencerModel | undefined;
};
function formatDateTime(dateString?: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export default function InfluencerDetailModal({ open, onClose, influencer }: Props) {
    const authContext = React.useContext(AuthContext);
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 12,
                    padding: '1rem',
                },
            }}
        >
            <DialogTitle disableTypography>
                <Typography variant="h6">Detalhe Influenciadores</Typography>
            </DialogTitle>

            <DialogContent dividers style={{ paddingTop: 16, paddingBottom: 16 }}>

                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Data de Recebimento" value={formatDateTime(influencer?.dataRecebimento)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Prazo de Entrega" value={formatDateTime(influencer?.prazoEntrega)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Validade da Análise" value={formatDateTime(influencer?.validadeAnalise)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Responsável Reputação" value={influencer?.responsavelReputacao} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Marca" value={influencer?.marca} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Área" value={influencer?.area} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Iniciativa" value={influencer?.iniciativa} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nome do Influenciador" value={influencer?.nome} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Url" value={influencer?.url_perfil} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Objetivo de contratação/parceria" value={influencer?.objetivoContratacao} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Tamanho" value={influencer?.tamanho} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Território" value={influencer?.territorio} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Finalidade" value={influencer?.finalidade} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Formato" value={influencer?.formato} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nível de Risco" value={influencer?.nivelRisco} />
                    </Grid>
                    {authContext.login.user.profile?.functionalities && (
                        <>
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Responsável Reputação') >= 0 && (
                                <Grid item xs={12}>
                                    <InfluencerModelField label="Observações" value={influencer?.observacoes} multiline
                                        minRows={5} />
                                </Grid>
                            )}
                        </>
                    )}
                    <Grid item xs={6}>
                        <InfluencerModelField label="Análise Reputacional" value={influencer?.analiseReputacional}
                            multiline
                            minRows={5} />
                    </Grid>
                    <Grid item xs={6}>
                        <InfluencerModelField label="Evidências" value={influencer?.evidencias} multiline
                            minRows={5} />
                    </Grid>

                </Grid>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: 8, textTransform: 'none' }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
